import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { PermissionDictionary, UserPermissionService } from 'src/app/services/user/user-permission.service';
import { TenantUIService } from '../../tenant-ui.service';
import { PermissionType } from 'src/app/models/user';
import { TenantService } from 'src/app/services/tenant/tenant.service';


@Component({
    selector: 'app-tenant-options',
    templateUrl: './tenant-options.component.html',
    styleUrls: ['./tenant-options.component.scss']
})
@AutoUnsubscribe({ arrayName: 'subscriptions' })
export class TenantOptionsComponent extends BaseComponent implements OnInit {

    PermissionDictionary = PermissionDictionary;

    constructor(
        public service: TenantUIService,
        private router: Router,
        private route: ActivatedRoute,
        public userPermissionService: UserPermissionService,
        private tenantService: TenantService
    ) {
        super();
    }

    async ngOnInit() {
        await this.registerPerms();

        this.subscriptions.push(this.route.paramMap.subscribe(params => {
            const entity = params.get('entity');
            if (entity) {
                this.service.selectEntity(entity);
            }
        }));
    }

    async registerPerms() {
        let permExclusions = [/UI\.Tenants\.Settings\.Editor/];
        this.tenantService.allTenantsSync.forEach(tenant => {
            if (tenant.tenantName) {
                const pattern = new RegExp("UI\\.Tenants\\." + tenant.tenantName);
                permExclusions.push(pattern);
            }}
        );
        await this.userPermissionService.registerPermissions([{ selectionName: 'UI.Tenants', permissionType: PermissionType.namespace }], permExclusions);
    }

    setEntity({ index }: { index: number }) {
        switch (index) {
            case 0:
                {
                    this.router.navigate(['./settings_editor'], { relativeTo: this.route.parent });
                }
                break;
            case this.service.ProductsIndex:
                {
                    this.router.navigate(['./products'], { relativeTo: this.route.parent });
                }
                break;
            case this.service.CampaignsIndex:
                {
                    this.router.navigate(['./campaigns'], { relativeTo: this.route.parent });
                }
                break;
            case this.service.IngestionIndex:
                {
                    this.router.navigate(['./ingestion'], { relativeTo: this.route.parent });
                }
                break;
        }
    }
}
